import {Box, Tab, TabList, TabPanel, TabPanels, Tabs, Text} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {FC, useState} from 'react';
import {TranslationKeys} from 'translations';
import {IPreOrderData, IPreOrderResponse} from 'types';

import {SelectTimeBtn} from './components';

interface IProps {
  currentPreOrder?: IPreOrderData;
  preOrder: IPreOrderResponse[];
  onChange: (date?: IPreOrderData) => void;
  delayTime?: string;
  t: (term: TranslationKeys) => string;
  restaurantClosed: boolean;
}

export const AddPreOrder: FC<IProps> = ({currentPreOrder, preOrder, onChange, delayTime, t, restaurantClosed}) => {
  const [tabIndex, setTabIndex] = useState(0);

  const selectPreOrder = (date?: IPreOrderData) => {
    onChange(date);
  };

  const handleTabsChange = (index: number) => {
    setTabIndex(index);
  };

  if (!preOrder) return null;

  return (
    <Tabs isFitted index={tabIndex} borderRadius="22px" p="5px 10px" variant="soft-rounded" onChange={handleTabsChange}>
      <TabList borderTopRadius="16px" bg={colors.bodyBackground} p="8px" borderRadius="16px">
        {preOrder &&
          preOrder.map((preOrdersData, index) => {
            const currentDay = index === 0 ? `${t('TODAY')}` : `${t('TOMORROW')}`;
            const isActive = tabIndex === index;
            return (
              <Tab
                key={index}
                _focus={{border: 'none'}}
                _selected={{
                  bg: colors.white,
                  border: 'none',
                }}
                p="13px 18px"
                borderRadius="16px"
              >
                <Box>
                  <Text color={isActive ? colors.black : 'auto'} fontSize={['12px', '16px']}>
                    {currentDay}
                  </Text>
                </Box>
              </Tab>
            );
          })}
      </TabList>
      {restaurantClosed ? null : (
        <>
          {tabIndex === 0 && (
            <Box mt="10px">
              <SelectTimeBtn isActive={!currentPreOrder} onSelect={() => selectPreOrder()}>
                {t('DELIVERY_TIME')}: {delayTime} {t('MINUTES')}
              </SelectTimeBtn>
            </Box>
          )}
        </>
      )}

      <TabPanels>
        {preOrder &&
          preOrder.map((preOrdersData, index) => (
            <TabPanel overflowY="scroll" h="365px" px="0px" key={index}>
              {preOrdersData.hours.map((hour) => {
                const isActive = currentPreOrder?.hour.value === hour.value;

                return (
                  <Box key={hour.value}>
                    <SelectTimeBtn
                      isActive={isActive}
                      onSelect={() =>
                        selectPreOrder({
                          value: preOrdersData.value,
                          hour: hour,
                        })
                      }
                    >
                      {hour.display}
                    </SelectTimeBtn>
                  </Box>
                );
              })}
            </TabPanel>
          ))}
      </TabPanels>
    </Tabs>
  );
};
